<template>
  <el-header height="56px">
    <div class="header--left-side">
      <component
        :is="require(menuCollapsed ? 'icons/Menu' : 'icons/MenuOpen').default"
        :size="24"
        class="menu-toggler"
        @click.capture="toggleMenu"
      />
    </div>
    <div class="header--right-side">
      <component :is="require('./elements/language_toggler').default" />
      <component
        :is="
          require(`./elements/app_header_${user.token ? '' : 'not'}logged`)
            .default
        "
      />
    </div>
  </el-header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "app_header",
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    ...mapActions("cache/shared_menu", ["toggleMenu"])
  },
  computed: {
    ...mapGetters({
      menuCollapsed: "cache/shared_menu/isCollapsed"
    })
  }
};
</script>

<style scoped lang="stylus">
.el-header
    font-size 24px
    display flex
    justify-content space-between

    & > div
        display flex

.menu-toggler
    cursor pointer;
</style>
